import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostPartenaire(action) {
	try {
		const result = yield fromApi.partenairePost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_PARTENAIRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetPartenaires(action) {
	try {
		const result = yield fromApi.partenairesGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_PARTENAIRES_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetPartenaire(action) {
	try {
		const result = yield fromApi.partenaireGet(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_PARTENAIRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutPartenaire(action) {
	try {
		const result = yield fromApi.partenairePut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_PARTENAIRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelPartenaire(action) {
	try {
		const result = yield fromApi.partenaireDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_PARTENAIRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* partenaires() {
	yield takeLatest('POST_PARTENAIRE_SAGAS', watchPostPartenaire);
	yield takeLatest('GET_PARTENAIRES_SAGAS', watchGetPartenaires);
	yield takeLatest('GET_PARTENAIRE_SAGAS', watchGetPartenaire);
	yield takeLatest('PUT_PARTENAIRE_SAGAS', watchPutPartenaire);
	yield takeLatest('DEL_PARTENAIRE_SAGAS', watchDelPartenaire);
}

export default function* rootSaga() {
	yield all([partenaires()]);
}
